var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],staticClass:"position-relative w-100 h-100",attrs:{"id":"app"}},[_c('router-view'),_c('vue-snotify')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }